module.exports = __webpack_public_path__ + "static/media/unlock.b603766c.svg";